import React from "react";

function DiscoveryLoading({ isVisible = true }) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-pink-50 via-purple-50 to-indigo-50 flex items-center justify-center z-50">
      {/* Circular Loading Spinner */}
      <div className="relative w-32 h-32 flex items-center justify-center">
        {/* Main spinner container */}
        <svg
          className="w-32 h-32 animate-spin"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Dot 1 */}
          <circle cx="50" cy="15" r="6" fill="#EC4899" opacity="1" />
          {/* Dot 2 */}
          <circle cx="72.65" cy="22.35" r="6" fill="#DB2777" opacity="0.9" />
          {/* Dot 3 */}
          <circle cx="85" cy="50" r="6" fill="#BE185D" opacity="0.8" />
          {/* Dot 4 */}
          <circle cx="72.65" cy="77.65" r="6" fill="#9D174D" opacity="0.7" />
          {/* Dot 5 */}
          <circle cx="50" cy="85" r="6" fill="#831843" opacity="0.6" />
          {/* Dot 6 */}
          <circle cx="27.35" cy="77.65" r="6" fill="#C084FC" opacity="0.7" />
          {/* Dot 7 */}
          <circle cx="15" cy="50" r="6" fill="#A855F7" opacity="0.8" />
          {/* Dot 8 */}
          <circle cx="27.35" cy="22.35" r="6" fill="#9333EA" opacity="0.9" />
        </svg>

        {/* Center heart icon */}
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-4xl animate-pulse">💖</span>
        </div>
      </div>

      {/* Loading text below spinner */}
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        .animate-spin {
          animation: spin 1.5s linear infinite;
        }
      `}</style>
    </div>
  );
}

export default DiscoveryLoading;
